// Module
var code = "<template> <require from=\"app/cd/components/summary/member/member-summary\"></require> <member-summary member-id.bind=\"member.id\"></member-summary> </template> ";
// Exports
module.exports = code;